import klineStyle from '../echartsOption/klineStyle';

/**
 * 定义异常交易成交量类
 */
class ABNORMALVOLUME {
    /**
     * 异常交易成交量类构造函数
     * @param {Array<Object>} datas 异常交易成交量数据
     * @param {Array<Number>} times 交易时间序列
     */
    constructor(datas, times) {
        this.datas = datas;
        this.times = times;
        this.buyDatas = [];
        this.sellDatas = [];

        this.seriesOptions = [
            {
                name: '大单托单',
                type: 'bar',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: [],
                barGap: '-100%',
                itemStyle: {
                    color: klineStyle.lineColor.color
                }
            },
            {
                name: '大单压单',
                type: 'bar',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: [],
                barGap: '-100%',
                itemStyle: {
                    color: klineStyle.lineColor.color0
                }
            }
        ];
    }

    /**
     * 按照K线完整的时间序列，处理异常交易的成交量数据
     */
    calculate() {
        this.buyDatas = [];
        this.sellDatas = [];

        this.times.forEach((time, index) => {
            this.buyDatas.push(null);
            this.sellDatas.push(null);
            this.datas.forEach(data => {
                if (data.time !== time) {
                    return;
                }
                // 只画压盘和托盘，如果是压盘，则设置为负值，以便能向下画
                switch (data.orderType) {
                    case 'sell':
                        this.sellDatas.pop();
                        this.sellDatas.push(-data.count);
                        break;
                    case 'buy':
                        this.buyDatas.pop();
                        this.buyDatas.push(data.count);
                        break;
                }
            });
        });
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        this.seriesOptions[0].data = this.buyDatas;
        this.seriesOptions[1].data = this.sellDatas;
        return this.seriesOptions;
    }
}

export default ABNORMALVOLUME;



// WEBPACK FOOTER //
// ./src/controller/series/ABNORMALVOLUME.js